export default "__VITE_ASSET__DEzMFJlo__"